import { UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useSharedScanRawAlarm(sharedToken: string) {
  const host = window.location.hostname;
  const baseUrl =
    host === 'localhost'
      ? `http://${host}:${window.location.port}`
      : `https://event-flow-${host}`;

  const url = `${baseUrl}/shared/api/event?sharedToken=${sharedToken}`;
  const request = new Request(url);

  return useAuthenticatedRequest<UnifiedAlarm>(request, {
    queryKey: ['scan_raw_alarm', 'shared', sharedToken],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    noAuth: true,
  });
}

export default useSharedScanRawAlarm;
